import { coerceValueRef } from "../authContext";
import type {
  AuthDescriptor,
  HeaderEntryRef,
  HeaderEntryRefInput,
} from "../authDescriptor";

function coerceHeader(h: HeaderEntryRefInput): HeaderEntryRef {
  return { name: h.name, value: coerceValueRef(h.value), scheme: h.scheme };
}

// Frozen so that the shared singleton can't be mutated by any consumer of
// `auth: oauthAuth` and accidentally bleed state across manifests.
export const oauthAuth: AuthDescriptor & {
  withHeaders: (extraHeaders: HeaderEntryRefInput[]) => AuthDescriptor;
} = Object.freeze(
  Object.assign({ type: "oauth" } as AuthDescriptor, {
    withHeaders: (extraHeaders: HeaderEntryRefInput[]): AuthDescriptor => ({
      type: "oauth",
      extraHeaders: extraHeaders.map(coerceHeader),
    }),
  })
);
